import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class OrganisationalKnowledge extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'organisationalKnowledge'}
            title={ t('support.procedure.P4.title') }
            exportTitle={ t('support.procedure.P4.exportTitle') }
            exportFileName={'organisationalKnowledge.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (OrganisationalKnowledge);